import React, { Fragment } from 'react';
import { Form, InputNumber } from 'antd';

const PaymentDeadlineInDays = ({ form, disabled }) => {
  const { getFieldDecorator } = form;
  return (
    <Fragment>
      <div className="monetization-field__item2">
        <span className="label">Cрок оплаты</span>
        <Form.Item>
          {getFieldDecorator('s1')(
            <InputNumber
              style={{ width: 80 }}
              disabled={disabled}
              placeholder="Укажите"
            />
          )}
        </Form.Item>
        <span className="label">дней</span>
      </div>
    </Fragment>
  );
};

export default PaymentDeadlineInDays;
